import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useForgotPasswordControllerForgotPasswordMutation } from '@shared/services/apiService/apiService';
import { getApiErrorMessage } from '@shared/utils/apiError.utils';

import { ForgotFormValue } from '../modal/type';

export const useForgotPassword = () => {
  const { t } = useTranslation();
  const [forgotPasswordMutation, { isLoading }] =
    useForgotPasswordControllerForgotPasswordMutation();
  const [errorMsg, setErrorMsg] = useState('');
  const [successMSg, setSuccessMsg] = useState('');

  const { handleSubmit, setValue, ...formMethods } = useForm<ForgotFormValue>({
    mode: 'onTouched',
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = handleSubmit(async (data) => {
    setErrorMsg('');
    setSuccessMsg('');

    const res = await forgotPasswordMutation({
      forgotPasswordRequestDto: {
        email: data.email,
      },
    });

    if (res.error) {
      setSuccessMsg('');
      setErrorMsg(getApiErrorMessage(res.error, t('forgot.forgotPassword.unknownError')));
    } else {
      setErrorMsg('');
      setSuccessMsg(t('forgot.forgotPassword.success'));
    }
  });

  return {
    setValue,
    onSubmit,
    errorMsg,
    successMSg,
    isLoading,
    ...formMethods,
  };
};
